<template>
  <div>
    <section class="hero is-fullheight" :style="{'background-image': `linear-gradient(rgba(0,0,0,0.65),rgba(0,0,0,0.65)), url(${require(`@/assets/${project.bg}`)})`}"> 
      <!-- :style="{
      backgroundImage: `url(require(../assets/fc-bg.jpg))``}"> -->
<!-- 

    "background: linear-gradient(rgba(0,0,0,0.65),rgba(0,0,0,0.65)), url('../assets/{{project.bg}}');"> -->
      <div class="hero-head">
      </div>
      <div class="hero-body">
        <div class="container">
          <div class="columns">
           <div class="column is-two-thirds">
            <img class="company-logo" :src="require(`@/assets/${project.logo}`)"/>
            <div class="level"></div>
            <h2>{{project.title}}</h2>
            <br>
            <p>{{project.description}}</p>
            <a v-if="project.link" :href="project.link" target="_blank">See It</a>
            <div class="level"></div>
            <div class="level"></div>
            <h4>Our Part</h4>
            <ul>
              <li v-for="speciality in project.specialties">{{speciality}}</li>
            </ul>
           </div>
           <div class="column has-text-right-desktop">
            <button class="button is-info is-inverted is-outlined"  @click="isModalActive = true">More info</button>
           </div>
           
          </div>
        </div>
      </div>
      <div class="hero-foot"></div>
    </section>
    <b-modal :active.sync="isModalActive" scroll="clip">
      <section class="hero is-fullheight" style="background-color: #FFF200">
        <div class="hero-head">
        </div>
        <div class="hero-body">
          <contact-form :context="project.name"></contact-form>
        </div>
        <div class="hero-foot"></div>
      </section>
    </b-modal>
  </div>
</template>

<script>
  import ContactForm from '@/components/ContactForm'
export default {
  name: 'Work',
  components: {ContactForm},
  props: ['project'],
  data() {
    return {
      isModalActive: false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .company-logo {
    height: 45px;
  }
  .hero {
    color: white !important;
    background-size: cover;
    background-position: 50%;
    background-repeat: no-repeat;
  }
  .hero-body {
    color: white;
  }
  .button.is-info.is-inverted.is-outlined:hover, .button.is-info.is-inverted.is-outlined:focus {
    color: black;
  }
  
</style>



// WEBPACK FOOTER //
// src/components/WorkProject.vue